import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { projectFeedFailingProjectsBackend } from './project-feed-failing-projects.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { projectFeedFailingProjectsReducer } from './project-feed-failing-projects.reducer';

// FIXME: remove that
backend.projectFeedFailingProjects = projectFeedFailingProjectsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectFeedFailingProjects',
      projectFeedFailingProjectsReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'projectFeedFailingProjects',
      projectFeedFailingProjectsBackend,
    ),*/
  ],
})
export class DatastoreProjectFeedFailingProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-projects/project-feed-failing-projects.module.ts